import { environment } from './../../../../../environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { DependencesService } from '../../../../services/dependences.service';
import * as moment from 'moment';
import { FilesService } from '../../../../services/files.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Component({
  selector: 'ngx-agreements',
  templateUrl: './agreements.component.html',
  styleUrls: ['./agreements.component.scss']
})
export class AgreementsComponent implements OnInit {
  @Input() requirement: any;
  @Input() stationId: string;

  loading = false
  inputAgreement = ''
  withAgreement = false
  data = {
    date_created: new Date(),
    num_review: 0,
    date_review: new Date(),
    date_authorization: new Date(),
    date_approved: new Date(),
    legal_requirement_requirement_id: null,
    station_legal_requirement_id: null,
    days_attend_notification: '',
    today: moment().format('YYYY-MM-DD'),
    status: '',
    updated_at: '',
    agreements: [],
    last_agreements: []
  }


  constructor(
    protected ref: NbDialogRef<AgreementsComponent>,
    protected DependencesService: DependencesService,
    private ToastrService: NbToastrService,
    private fileService: FilesService,
  ) { }

  ngOnInit() {
    let agreement: any = null
    if (this.requirement.requirement && this.requirement.requirement.agreement) agreement = this.requirement.requirement.agreement
    else agreement = this.requirement.agreement 
    if (agreement) {
      this.withAgreement = true
      this.data.date_created = agreement.date_created
      this.data.num_review = (agreement.num_review + 1).toString()
      this.data.updated_at = moment(agreement.updated_at).format('YYYY-MM-DD')
      this.data.last_agreements = agreement.agreements || []
    }
    if (
      this.requirement.requirement || this.requirement.legal_requirement_requirement_id || this.requirement.pivot
    ) this.data.legal_requirement_requirement_id = this.requirement.legal_requirement_requirement_id || this.requirement.pivot.legal_requirement_requirement_id || this.requirement.requirement.id
    else this.data.station_legal_requirement_id = this.requirement.id
  }

  close() { this.ref.close(false); }

  appendAgreement () {
    this.inputAgreement = this.inputAgreement.trim()
    if (this.inputAgreement === '') return
    this.data.agreements.push(this.inputAgreement)
    this.inputAgreement = ''
    this.ToastrService.show('Se agrego acuerdo', 'Éxito', { status: 'success' })
  }

  removeAgreement (index: number) {
    this.data.agreements.splice(index, 1)
    this.ToastrService.show('Se quito el acuerdo', 'Éxito', { status: 'danger' })
  }

  async store() {
    this.loading = true;
    const [error] = await this.DependencesService.storeAgreement(this.stationId, this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Ocurrio algo intentalo mas tarde');
    }
    if (this.withAgreement) await this.download()
    this.loading = false
    this.ToastrService.show('Se guardaron acuerdos', 'Éxito', { status: 'success' })
    this.ref.close(true);
  }

  async download () {
    let queryParam = '';
    if (this.data.station_legal_requirement_id) queryParam = '?station_legal_requirement_id=' + this.data.station_legal_requirement_id
    else queryParam = '?legal_requirement_requirement_id=' + this.data.legal_requirement_requirement_id
    const url = `${environment.baseEndpoint}/dependencesv2/station/${this.stationId}/monitoring${queryParam}`;
    return await this.fileService.downloadFile((url), `p_seguimiento_${this.stationId}`, 'docx');
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
